import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance, AxiosResponse } from 'axios';
import moment from 'moment';
import { MOMENT_DATE_FORMAT } from '../constants/date_format';

class CampusApi {
    httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetCampuses() {
        const { data } = await this.httpClient.get(`/campuses`);
        return data;
    }
}

export default CampusApi;
